var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTheme } from "../hooks/useTheme";
import { LibIcon } from './components';
var Menu = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 15 : _b, _c = _a.lss, lss = _c === void 0 ? { color: 'primary500' } : _c, _d = _a.title, title = _d === void 0 ? '' : _d, props = __rest(_a, ["size", "lss", "title"]);
    var theme = useTheme();
    return (React.createElement("svg", __assign({ width: size, height: size, viewBox: "0 0 20 20" }, props),
        title && React.createElement("title", null, title),
        React.createElement("g", { id: "Impact-Measurement", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { id: "Group-156", fill: theme.colors[lss.color] },
                React.createElement("g", { id: "Group-148" },
                    React.createElement("circle", { id: "Oval", cx: "2.5", cy: "2.5", r: "2.5" }),
                    React.createElement("circle", { id: "Oval-Copy-28", cx: "2.5", cy: "10", r: "2.5" }),
                    React.createElement("circle", { id: "Oval-Copy-31", cx: "2.5", cy: "17.5", r: "2.5" }),
                    React.createElement("circle", { id: "Oval-Copy-26", cx: "10", cy: "2.5", r: "2.5" }),
                    React.createElement("circle", { id: "Oval-Copy-29", cx: "10", cy: "10", r: "2.5" }),
                    React.createElement("circle", { id: "Oval-Copy-32", cx: "10", cy: "17.5", r: "2.5" }),
                    React.createElement("circle", { id: "Oval-Copy-27", cx: "17.5", cy: "2.5", r: "2.5" }),
                    React.createElement("circle", { id: "Oval-Copy-30", cx: "17.5", cy: "10", r: "2.5" }),
                    React.createElement("circle", { id: "Oval-Copy-33", cx: "17.5", cy: "17.5", r: "2.5" }))))));
};
export var MenuIcon = function (props) { return (React.createElement(LibIcon, __assign({ icon: Menu }, props))); };
//# sourceMappingURL=MenuIcon.js.map